import React from "react"
import {Helmet} from "react-helmet";
import HeaderNormal from "../header/HeaderNormal";
import {Container} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import TitleSection from "../heading/TitleSection";
import Footer from "../footer/Footer";
import ProductionVideoList from "./ProductionVideoList";

export const ProductionVideo = () => {
    const {t} = useTranslation("common")

    return (
        <React.Fragment>
            <Helmet>
                <title>OUR PRODUCTION VIDEO - Stéphane Kamwa</title>
                <meta
                    name="description"
                    content="Découvrez nos productions vidéo : films, interviews et contenus publicitaires."
                />
                <link rel="canonical" href="https://www.comtheplug.com/video-production" />
            </Helmet>

            <HeaderNormal className="background-section text-uppercase" description={t("Nos dernières réalisations")}>
                {t("Notre Production Vidéo")} 
            </HeaderNormal>

            <Container className="mt-section">
                <TitleSection description={t("Projets vidéo réalisés")} />
                <ProductionVideoList />
            </Container>

            <br /><br />
            <Footer/>
        </React.Fragment>
    )
}
